<template>
  <div class="indexBox">
    <img class="WLJY_logo" v-if="matchId == 219 || matchId == 220 || matchId == 221 || matchId == 222|| matchId == 223" src="https://mc.posedu.com.cn/myAll_Img/WLJY_logo.png" />
    <img :src="hostUrl" alt="" style="height: 4.8rem;position: absolute;left: 2.5rem;top: 2rem;" v-if="hostUrl">
    <img :src="technicalSupportUrl" alt="" style="height: 4.8rem;position: absolute;right: 2.5rem;top: 2rem;" v-if="hostUrl && technicalSupportUrl">
    <img :src="technicalSupportUrl" alt="" style="height: 4.8rem;position: absolute;left: 2.5rem;top: 2rem;" v-if="!hostUrl && technicalSupportUrl">

    <div class="bigTitleBack bg">
      <div class="bigTitle">选手答题</div>
    </div>
    <div class="mainBack bg">
      <div class="title bg">
        {{studentObj.sort}}号选手
      </div>
      <div class="questions" v-if="randomQuestionsArr.length>0">{{randomQuestionsArr[randomNum].name}}</div>

      <div class="numBox" v-if="countdown && countdown!='00:00'">
        <div
        :class="minute==0&& second<=10 && second>0 && suspend?'numRed numRed_animation':
        (minute==0 && second==0) || (minute==0 && second<=10 && !suspend)?'numRed':'num'">
        {{minute<10?'0'+minute:minute}}:{{second<10?'0'+second:second}}</div>
        <!-- <div class="num">{{minute<10?'0'+minute:minute}}:{{second<10?'0'+second:second}}</div> -->
        <img class="lightDisk" src="https://mc.posedu.com.cn/myAll_Img/lightDisk.png" />
      </div>
    </div>
    <div class="bottomBox">
      <img class="Decoration" src="https://mc.posedu.com.cn/myAll_Img/bot_left_Decoration.png" />
      <img class="Decoration" src="https://mc.posedu.com.cn/myAll_Img/bot_right_Decoration.png" />
    </div>
    <audio id="myaudio" controls="controls" hidden src="https://mc.posedu.com.cn/myAll_Img/time_sound.mp3?1"
      ref="audio"></audio>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        countdown: null, //倒计时
        minute: '', //分钟
        second: '', //秒
        randomNum: 0, //随机数
        internalSelection: null, //你懂得
        setIntervalFun: null, //计时器
        randomQuestionsArr: [], //题目数组
        matchId: '',
        studentObj: {}, //选手信息
        status: 0, //抽题状态  0-停止抽题  1-开始抽题
        circulateFunTime: null,
        countdownGO_FunTime: null, // 倒计时函数
        playerId: 0, //选手id
        pagesArr: ['/pages/index', '/pages/playerQuestions', '/pages/scoring', '/pages/playerRanking',
            '/pages/countdown','/pages/totalScore_player'
          ], //首页banner、选题、打分、排行、倒计时、总分
        suspend: true, //倒计时是否进行中
            hostUrl:'',
        technicalSupportUrl:''

      };
    },
    mounted() {
      this.matchId = this.$route.query.matchId;
      let that = this
      this.$get("getCache", '?trackId=1', {
          matchId: this.matchId,
        }).then((res) => {
          // 获取题目列表
          // //console.log('getCache', res.data);
          this.randomQuestionsArr = res.data.topics_list
        })
        .catch((err) => {});
      this.$get("gerSecondConsoleInfo", '?trackId=1', {
          matchId: this.matchId,
        }).then((res) => {
          this.mytype = res.data.type
          this.playerId = res.data.playerId
          this.countdown = res.data.countDownSeconds
          this.minute = parseInt(this.countdown.split(':')[0])
          this.second = parseInt(this.countdown.split(':')[1])
          this.playerFun()
          setTimeout(() => {
            that.data_acquisition()
          }, 1000);
        })
        .catch((err) => {});
      document.addEventListener("keydown", this.clearIntervalFun);
      // this.countdownGO_Fun()
      // this.enterKeyup()
      this.hostUrl = sessionStorage.getItem('hostUrl')
      this.technicalSupportUrl = sessionStorage.getItem('technicalSupportUrl')
    },
    destroyed() {
      //console.log("销毁");
      let that = this
      // 销毁enter事件
      this.$refs.audio.pause(); //停止
      document.removeEventListener("keydown", this.clearIntervalFun);
      window.clearInterval(that.setIntervalFun)
      window.clearTimeout(that.circulateFunTime)
      window.clearInterval(that.countdownGO_FunTime)
    },
    methods: {
      // 按下回车控制 开始/停止选题
      clearIntervalFun(event) {
        let that = this
        //console.log("event", event);
        if (event.key == 'Enter') {
          if (this.status == 0) {
            this.status = 1
            this.goextractQuestions()
            this.drawQuestionsFun()
          } else if (this.status == 1) {
            this.status = 0
            if (this.internalSelection != null) {
              this.randomNum = this.internalSelection
              this.internalSelection = null
            }
            window.clearInterval(that.setIntervalFun)
            this.drawQuestionsFun()
          }
        }
      },
      // 开始抽题
      goextractQuestions() {
        let that = this
        that.setIntervalFun = window.setInterval(() => {
          that.randomNum = Math.floor(Math.random() * that.randomQuestionsArr.length); // 取随机整数。
        }, 50)
      },
      // 倒计时
      countdownGO_Fun() {
        this.suspend = true
        let that = this
        //console.log("minute_second", this.minute, this.second);
        that.countdownGO_FunTime = window.setInterval(() => {
          if (that.second > 0) {
            that.second -= 1
            if (that.minute == 0 && that.second <= 10 && this.$store.state.audioShow == 1) {
              that.radioFun()
            }
          } else {
            if (that.minute > 0) {
              that.minute -= 1
              that.second = 59
              if (that.minute == 0 && that.second == 59 && this.$store.state.audioShow == 1) {
                that.radioFun()
              }
            } else {
              window.clearInterval(that.countdownGO_FunTime)
            }
          }
        }, 1000)
      },
      radioFun() {
        this.$refs.audio.currentTime = 0; //从头开始播放
        this.$refs.audio.play(); //播放
        setTimeout(() => {
          this.$refs.audio.pause(); //停止
        }, 800);
      },
      data_acquisition() {
        this.$get("gerSecondConsoleInfo", '?trackId=1', {
            matchId: this.matchId,
          }).then((res) => {
            sessionStorage.setItem('screenModal', res.data.currentScreenModal?res.data.currentScreenModal:1)
            if(res.data.currentScreenModal && res.data.currentScreenModal!=1){
              window.location.reload();
            }
            //console.log('gerSecondConsoleInfo', res.data);
            let that = this
            if (res.data.type == 4) {
              if (this.playerId == res.data.playerId) {
                // 倒计时监听
                if (res.data.countDownStatus == 0) {
                  window.clearInterval(that.countdownGO_FunTime)
                  this.suspend = false
                  this.countdown = res.data.countDownSeconds
                  this.minute = parseInt(this.countdown.split(':')[0])
                  this.second = parseInt(this.countdown.split(':')[1])
                } else if (res.data.countDownStatus == 1) {
                  if (this.minute == parseInt(this.countdown.split(':')[0]) && this.second == parseInt(this.countdown.split(':')[1])) {
                    this.countdownGO_Fun()
                  }
                } else if (res.data.countDownStatus == 2) {
                  window.clearInterval(that.countdownGO_FunTime)
                  this.suspend = false
                  this.countdown = this.minute+':'+this.second
                }
                // 抽题监听
                if (res.data.topicStatus == 1) {
                  if (this.status != 1) {
                    this.status = 1
                    this.goextractQuestions()
                  }
                } else if (res.data.topicStatus == 0) {
                  this.status = 0
                  window.clearInterval(that.setIntervalFun)
                }
              } else {
                window.clearInterval(that.countdownGO_FunTime)
                this.mytype = res.data.type
                this.playerId = res.data.playerId
                this.countdown = res.data.countDownSeconds
                this.minute = parseInt(this.countdown.split(':')[0])
                this.second = parseInt(this.countdown.split(':')[1])
                this.playerFun()
              }
              this.circulateFunTime = window.setTimeout(() => {
                that.data_acquisition()
              }, 1000);
            } else {
              window.clearTimeout(that.circulateFunTime)
              let routerNum = null
              if (res.data.type == null) {
                routerNum = 0
              } else if (res.data.type == 3 || res.data.type == 5 || res.data.type == 10) {
                routerNum = 2
              } else if (res.data.type == 9) {
                routerNum = 3
              }else if(res.data.type == 1 || res.data.type == 2 || res.data.type == 7){
                routerNum = 4
              }else if(res.data.type == 6){
                routerNum = 5
              }
              if (routerNum != null) {
                this.$router.push({
                  path: this.pagesArr[routerNum],
                  query: {
                    matchId: this.matchId,
                    soundOver:true
                  },
                });
                window.clearTimeout(that.circulateFunTime)
              }
            }
          })
          .catch((err) => {});
      },
      drawQuestionsFun() {
        // 提交抽题
        this.$get("drawQuestions", `?trackId=1&status=${this.status}`, {
            matchId: this.matchId,
          }).then((player_res) => {})
          .catch((err) => {});
      },
      playerFun() {
        this.$get("playerPOST", this.playerId, {
            matchId: this.matchId,
          }).then((player_res) => {
            //console.log('选手信息', player_res.data);
            this.studentObj = player_res.data
          })
          .catch((err) => {});
      },
    }
  }

</script>
<style scoped>

  .bg {
    background-position: 0 0;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  * {
    padding: 0;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .indexBox {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
    background-image: url(https://mc.posedu.com.cn/myAll_Img/backOne.png);
    overflow: hidden;
  }

  .bigTitleBack {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/bigTitle.png);
    font-size: 2.8125rem;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    width: 70.9375rem;
    height: 5rem;
    display: flex;
    justify-content: center;

  }

  .bigTitleBack .bigTitle {
    color: #4997FE;
    background-image: -webkit-linear-gradient(top, #79CBFB, #4997FE);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .mainBack {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/countDownBack.png);
    width: calc(100% - 21rem);
    height: 46.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3.125rem 4.25rem 1.875rem;
    position: relative;
    margin-top: 2.8125rem;
  }

  .mainBack .title {
    background-image: url(https://mc.posedu.com.cn/myAll_Img/playerBack.png);
    width: 32.220625rem;
    height: 7.875rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 4.5rem;
    font-family: PingFang SC-Semibold, PingFang SC;
    color: #A5F9F9;
    line-height: 4rem;
  }

  .mainBack .questions {
    font-size: 5.5rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 11.875rem;
    margin-top: 5rem;
  }

  .mainBack .numBox {
    position: absolute;
    right: 3.0625rem;
    top: 2.375rem;
  }

  .mainBack .numBox .num {
    font-size: 5rem;
    font-family: DIN Condensed-Bold, DIN Condensed;
    font-weight: bold;
    color: #1B6DC1;
    text-align: center;
    background: linear-gradient(180deg, #A5F9F9 0%, #1B6DC1 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .numBox .numRed {
    font-size: 5rem;
    font-family: DIN Condensed-Bold, DIN Condensed;
    font-weight: bold;
    color: #FF0000;
    text-align: center;
    background: linear-gradient(180deg, #FB7474 0%, #FF0000 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .lightDisk {
    margin: -5.9375rem 0 0 1.5rem;
    width: 16.25rem;
  }

  .bottomBox {
    margin-top: 1.25rem;
    width: calc(100% - 15.625rem);
    display: flex;
    justify-content: space-between;
  }

  .Decoration {
    height: 6.25rem;
  }

</style>



// WEBPACK FOOTER //
// src/pages/playerQuestions.vue